import { render, staticRenderFns } from "./ParagraphSettingsFields.vue?vue&type=template&id=2d0c2b22&scoped=true&"
import script from "./ParagraphSettingsFields.vue?vue&type=script&lang=ts&"
export * from "./ParagraphSettingsFields.vue?vue&type=script&lang=ts&"
import style0 from "./ParagraphSettingsFields.vue?vue&type=style&index=0&id=2d0c2b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c2b22",
  null
  
)

export default component.exports